var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxSeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box-seam",
    clipPath: "url(#clip0_1496_48686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.279 2.16961C12.0999 2.09784 11.9001 2.09784 11.721 2.16961L2.769 5.75011L6.375 7.19161L15.606 3.50011L12.279 2.16961ZM17.625 4.30861L8.394 8.00011L12 9.44161L21.231 5.75011L17.625 4.30861ZM22.5 6.85861L12.75 10.7586V22.6416L22.5 18.7416V6.86011V6.85861ZM11.25 22.6431V10.7571L1.5 6.85861V18.7431L11.25 22.6431ZM11.1645 0.77611C11.7008 0.561609 12.2992 0.561609 12.8355 0.77611L23.529 5.05411C23.668 5.10983 23.7872 5.2059 23.8711 5.32994C23.9551 5.45399 24 5.60033 24 5.75011V18.7431C23.9998 19.0428 23.9098 19.3356 23.7417 19.5838C23.5735 19.8319 23.3348 20.0239 23.0565 20.1351L12.279 24.4461C12.0999 24.5179 11.9001 24.5179 11.721 24.4461L0.945 20.1351C0.666377 20.0241 0.427414 19.8322 0.258963 19.5841C0.0905126 19.3359 0.000309494 19.043 0 18.7431L0 5.75011C3.48599e-05 5.60033 0.0449156 5.45399 0.128861 5.32994C0.212805 5.2059 0.331969 5.10983 0.471 5.05411L11.1645 0.77611Z",
    fill: "#DF992F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1496_48686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxSeam);
export default __webpack_public_path__ + "static/media/box-seam.119d6bb3fd209c9ba5009cc43155aea2.svg";
export { ForwardRef as ReactComponent };